<template>
  <bs-template-terminal v-if="auth.level >= 1000"></bs-template-terminal>
  <bs-template-owner v-else></bs-template-owner>
</template>
<script>
// import Vue from 'vue'
import BsTemplateOwner from './BsTemplateOwnerView.vue'
// import BsTemplatePos from './BsTemplatePosView.vue'
import BsTemplateTerminal from './BsTemplateTerminalView.vue'
// import BsTemplatePrinter from './BsTemplatePrinterView.vue'
export default {
  name: 'BsTemplate',
  data: function () {
    return {
      auth: this.$store.state.auth,
      menuDisplay: true
      //   count: this.$store.state.count
    }
  },
  components: {
    BsTemplateOwner,
    BsTemplateTerminal
    // BsTemplatePrinter,
    // BsTemplatePos,
  }
}
</script>
